import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Snackbar, SnackbarContent, colors, IconButton } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircleOutlined';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import WarningIcon from '@material-ui/icons/Warning';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
  root:{
    top:'50%'
  },
  errorContent: {
    backgroundColor: colors.red[600]
  },
  successContent: {
    backgroundColor: colors.green[600]
  },
  warningContent:{
    backgroundColor: colors.orange[600]
  },
  message: {
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    marginRight: theme.spacing(2)
  }
}));

const CustomSnackbar = props => {
  const { open, onClose, type, message, verticalCenter, anchorOrigin, successCSS} = props;

  const classes = useStyles();

  return (
    <Snackbar
      anchorOrigin={ 
        anchorOrigin ? 
          anchorOrigin 
        : 
          {
            vertical: 'top',
            horizontal: 'center'
          }
        }
      style={{zIndex:99999}}
      autoHideDuration={6000}
      className={verticalCenter ? classes.root : null}
      onClose={onClose}
      open={open}
    >
      <SnackbarContent
        className={ 
            type == 'Success' ? 
              classes.successContent 
            : 
              type == 'warning' ? 
                classes.warningContent 
              : classes.errorContent
          }

        style={successCSS ? props.successCSS : null}
        message={
          <span className={classes.message}>
            {type == 'Success' ? 
              <CheckCircleIcon className={classes.icon} />
              : 
                type == 'warning' ? 
                <WarningIcon className={classes.icon} />
                :
                <ErrorOutlineIcon className={classes.icon} />
            }
              {message}
          </span>
        }
        action={[
          <IconButton key="close" aria-label="close" color="inherit" onClick={onClose}>
            <CloseIcon className={classes.closeIcon} />
          </IconButton>,
        ]}
        variant="h6"
      />
    </Snackbar>
  );
};

CustomSnackbar.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired
};

CustomSnackbar.defaultProps = {
  open: true,
  onClose: () => {},
  type: 'Success',
  message: 'Successfully saved changes!'
};

export default CustomSnackbar;
